import type { SVGProps } from "react";

export const InfoCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 0 18 18"
    {...props}>
    <g fill={props.fill || "#0042E6"} fillRule="evenodd" clipPath="url(#a)" clipRule="evenodd">
      <path d="M.75 9a8.25 8.25 0 1 1 16.5 0A8.25 8.25 0 0 1 .75 9ZM9 2.25a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5Z" />
      <path d="M9 8.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V9A.75.75 0 0 1 9 8.25ZM8.25 6A.75.75 0 0 1 9 5.25h.008a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 6Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={props.fill || "#fff"} d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
